import React, { useEffect, useState } from 'react';
import { userService } from '../../services/api';

const PixKeyPage = () => {
  const [pixKey, setPixKey] = useState('');
  const [pixKeyType, setPixKeyType] = useState('EMAIL');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPixKey = async () => {
      try {
        const data = await userService.getMyPixKey();
        if (data?.pixKey) {
          setPixKey(data.pixKey);
        }
        if (data?.pixKeyType) {
          setPixKeyType(data.pixKeyType);
        }
      } catch (err) {
        console.error(err);
        setError('Não foi possível carregar sua chave PIX.');
      } finally {
        setLoading(false);
      }
    };

    fetchPixKey();
  }, []);

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');

    try {
      await userService.saveMyPixKey({ pixKey, pixKeyType });
      setMessage('Chave PIX salva. Agora os repasses caem direto na sua conta.');
    } catch (err) {
      console.error(err);
      setError('Erro ao salvar chave PIX. Confira os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Remover sua chave PIX? Você deixará de receber repasses automáticos.')) {
      return;
    }

    setSaving(true);
    setError('');
    setMessage('');

    try {
      await userService.deleteMyPixKey();
      setPixKey('');
      setMessage('Chave PIX removida.');
    } catch (err) {
      console.error(err);
      setError('Erro ao remover chave PIX.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando sua chave PIX...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa-duotone fa-key page-title-icon"></i>
          Minha chave PIX
        </h1>
        <p className="page-subtitle">Cadastre a chave onde quer receber os repasses.</p>
      </div>

      <div className="card-modern" style={{ padding: 24 }}>
        <form onSubmit={handleSave} className="form-grid">
          <div className="form-group">
            <label className="form-label">Tipo de chave</label>
            <select
              className="form-input"
              value={pixKeyType}
              onChange={(e) => setPixKeyType(e.target.value)}
              required
            >
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
              <option value="EMAIL">E-mail</option>
              <option value="TELEFONE">Telefone</option>
              <option value="CHAVE_ALEATORIA">Chave Aleatória (EVP)</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Chave PIX</label>
            <input
              type="text"
              className="form-input"
              placeholder="Digite sua chave PIX"
              value={pixKey}
              onChange={(e) => setPixKey(e.target.value)}
              required
            />
            <small style={{ color: 'var(--text-muted)' }}>
              Usamos essa chave somente para repassar pagamentos que você recebe.
            </small>
          </div>

          {message && (
            <div className="alert alert-success" role="alert">
              <i className="fa-solid fa-check" style={{ marginRight: 6 }}></i>
              {message}
            </div>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: 6 }}></i>
              {error}
            </div>
          )}

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              <i className={`fa-solid ${saving ? 'fa-rotate fa-spin' : 'fa-floppy-disk'}`}></i>
              {saving ? ' Salvando...' : ' Salvar chave'}
            </button>
            {pixKey && (
              <button type="button" className="btn btn-secondary" onClick={handleDelete} disabled={saving}>
                <i className="fa-solid fa-trash"></i> Remover chave
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PixKeyPage;
